import { lazy } from 'react';
import { LogListPage, LogDetailPage } from './imports';

export const logRoutes = [
  {
    path: 'logs',
    children: [
      { element: <LogListPage />, index: true },
      { path: 'list', element: <LogListPage /> },
      { path: ':id', element: <LogDetailPage /> },
      { path: 'new', element: <LogListPage /> },
    ],
  },
];
